/**
 * slotTime — временные хелперы сетки слотов (эталон screen-17-quests.js:8-11,
 * 332-333): парс/формат HH:MM, хронологический ключ с якорем 06:00, маска и
 * нормализация инлайн-ввода («930» → «09:30»).
 */
export const T_RE = /^([01]?\d|2[0-3]):[0-5]\d$/;

export const tm = (s: string): number | null => {
  const m = /^(\d{1,2}):(\d{2})$/.exec(s);
  return m ? Number(m[1]) * 60 + Number(m[2]) : null;
};

export const ft = (m: number): string =>
  `${String(Math.floor((m % 1440) / 60)).padStart(2, "0")}:${String(m % 60).padStart(2, "0")}`;

/** Хронология с якорем 06:00 — послеполуночные времена в конце (js:11). */
export const keyOf = (t: string): number => ((((tm(t) ?? 0) - 360) % 1440) + 1440) % 1440;

/** Маска ввода: только цифры, «:» после двух (js:332). */
export const maskT = (s: string): string => {
  const d = s.replace(/\D/g, "").slice(0, 4);
  return d.length > 2 ? `${d.slice(0, 2)}:${d.slice(2)}` : d;
};

/** Нормализация: «930»/«0930» → «09:30»; невалид → null (js:333). */
export const normT = (v0: string): string | null => {
  let v = v0;
  if (/^\d{3,4}$/.test(v)) v = (v.length === 3 ? "0" : "") + v.slice(0, 2) + ":" + v.slice(2);
  if (v && v.length === 4) v = `0${v}`;
  return T_RE.test(v) ? v : null;
};
